/**
 * Returns true if the value is an un-replaced build-time sentinel
 * (e.g. __SENTINEL_NEXT_PUBLIC_ADMIN_GRAPHQL_ENDPOINT__).
 *
 * Next.js inlines NEXT_PUBLIC_* values at build time. In the stage/main Docker
 * images, real values come from Bitwarden Secrets Manager and are only available
 * at container start. The entrypoint.sh replaces the sentinel strings at that
 * point — but if .env.local is absent, the sentinel strings remain in the bundle
 * and must be treated as missing.
 *
 * See docs/next-public-env-sentinel-pattern.md.
 */
export const isSentinelValue = (v: string | undefined): boolean => typeof v === "string" && v.startsWith("__SENTINEL_");
